import React from 'react';
import { Card, CardHeader } from '../../ui/Card';
import { StatusPill } from '../../ui/StatusPill';

const statusNames = {
  approved: 'Godkjent',
  published: 'Publisert',
  active: 'Aktiv',
  draft: 'Utkast',
  generated: 'Generert',
  under_review: 'Til gjennomgang',
  changes_requested: 'Endringer ønsket',
  archived: 'Arkivert'
};

function statusVariant(status) {
  if (['approved', 'published', 'active'].includes(status)) return 'healthy';
  if (status === 'draft' || status === 'archived') return 'ghost';
  return 'moderate';
}

export function AcademyAdminCourseTable({ courses }) {
  return (
    <Card>
      <CardHeader
        title="Kursoversikt"
        subtitle="Påmeldinger, fullføringer og aktive kursbevis per versjon"
      />
      {courses.length === 0 ? (
        <p className="p-6 text-sm text-slate-500">Ingen Academy-kurs er tilgjengelige.</p>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full min-w-[720px] text-left text-sm">
            <thead className="bg-slate-50 text-xs uppercase tracking-wide text-slate-500">
              <tr>
                <th className="px-6 py-4 font-semibold">Kursnavn</th>
                <th className="px-4 py-4 font-semibold">Versjon</th>
                <th className="px-4 py-4 font-semibold">Status</th>
                <th className="px-4 py-4 text-right font-semibold">Påmeldte</th>
                <th className="px-4 py-4 text-right font-semibold">Fullførte</th>
                <th className="px-6 py-4 text-right font-semibold">Kursbevis</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {courses.map((course) => (
                <tr key={course.id}>
                  <td className="px-6 py-4 font-semibold text-slate-800">{course.name}</td>
                  <td className="px-4 py-4 text-slate-600">{course.version}</td>
                  <td className="px-4 py-4">
                    <StatusPill
                      label={statusNames[course.status] || course.status}
                      variant={statusVariant(course.status)}
                    />
                  </td>
                  <td className="px-4 py-4 text-right tabular-nums">{course.enrollmentCount}</td>
                  <td className="px-4 py-4 text-right tabular-nums">{course.completionCount}</td>
                  <td className="px-6 py-4 text-right tabular-nums">{course.certificateCount}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </Card>
  );
}